export default __webpack_public_path__ + "static/media/fr1.f39cd21d.webp";